export const BUSINESSES = [
    {
        id:0,
        bus_name: "BOBZA",
        bus_owner: "Bogosi",
        room_name: "Kitchen"
    },
    {
        id:1,
        bus_name: "MATTIK",
        bus_owner: "MATTIK",
        room_name: "Kitchen"
    },
];